import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Terminal14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.43934 6.5L4.46967 5.53033L5.53033 4.46967L7.56066 6.5L5.53033 8.53033L4.46967 7.46967L5.43934 6.5Z'
      fill='currentColor'
    />
    <path d='M7 9.75H10V8.25H7V9.75Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.25 2.35714C1.25 1.74568 1.74568 1.25 2.35714 1.25H11.6429C12.2543 1.25 12.75 1.74568 12.75 2.35714V11.6429C12.75 12.2543 12.2543 12.75 11.6429 12.75H2.35714C1.74568 12.75 1.25 12.2543 1.25 11.6429V2.35714ZM2.75 2.75V11.25H11.25V2.75H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Terminal14.displayName = 'Terminal14';
export default Terminal14;
